import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { Line } from "@vds/lines";

import { media } from "utils/style";
import { ENDPOINTS } from "utils/endpoints";
import { setA11yContent } from "../NavigationHelper/actions";
import { fetchPageContent } from "../DownloadAndDelete/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import { ButtonWithArrow } from "common-components/Buttons";
import { LandingPageTabs as Tabs } from "common-components/LandingPageTabs";
import AEMContentFromHTML from "../../../hoc/AEMContentFromHTML";

class AccountNotSupported extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    this.props.fetchPageContent(ENDPOINTS.FETCH_ACCOUNT_NOT_SUPPORTED_PAGE).then(() => {
      this.setState({ loading: false });

      if (checkNestedObject(this.props.pageContent[0], "sc_pagetitle")) {
        this.props.setA11yContent("account not supported", this.props.pageContent[0].sc_pagetitle);
      }
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={{ maxWidth: "1272px", margin: "0 auto", padding: "0 20px" }}>
          <RectangleLoader />
        </div>
      );
    }

    const { pageContentFromAjax: pageContent } = this.props;
    const {
      landing_page_tabs: [landing_page_tabs]
    } = this.props.pageContent;

    return (
      <Fragment>
        <LandingPageTabs landing_page_tabs={landing_page_tabs} />
        <Container>
          <Header style={{ maxWidth: "596px" }}>{pageContent[0].section_title}</Header>
          <h2 style={{ marginTop: "40px", fontSize: "20px", lineHeight: "19px" }}>
            {pageContent[1].section_title}
          </h2>
          <Line style={{marginTop:"1.5rem"}} type="secondary"/>


          <div>
            <ButtonWithArrow
              style={{ marginBottom: "8px" }}
              buttonRole="link"
              href={pageContent[1].links[0].link}
            >
              {pageContent[1].links[0].text}
            </ButtonWithArrow>
            <p>{pageContent[1].links[0].desc}</p>
          </div>
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ pageContent }) => ({
  pageContentFromAjax: pageContent
});

export default compose(
  connect(
    mapStateToProps,
    { fetchPageContent, setA11yContent }
  ),
  AEMContentFromHTML
)(AccountNotSupported);

const LandingPageTabs = styled(Tabs)`
  padding: 0 20px;
`;

const Container = styled(CommonContainer)`
  margin: 0;
  padding: 80px 20px 440px 20px;

  ${media.mobile`
    padding: 48px 16px 100px 16px;
  `}
`;


